<template>
  <div class="modal" v-if="seen">
    <div class="permanent" v-if="!done">
      <p>
        <span>
          <svg style="width: 24px; height: 24px" viewBox="0 0 24 24">
            <path fill="#FC6D6C"
              d="M19,6.41L17.59,5L12,10.59L6.41,5L5,6.41L10.59,12L5,17.59L6.41,19L12,13.41L17.59,19L19,17.59L13.41,12L19,6.41Z" />
          </svg>
        </span>
      </p>
      <span>Moving <strong>files</strong> to
        <strong>{{ str_text(location) }}</strong></span>
      <br />
      <span><img src="@/assets/30.gif" /></span>
    </div>
    <div class="loading" v-if="done">
      <p class="note"><strong style="font-weight:bold;">Files</strong> copied to <strong style="font-weight:bold;">{{
        destination }}</strong></p>
      <p>
        <span class="btn cancel" @click="closebox">Cancel</span> &nbsp;&nbsp; <span class="btn ok" @click="goto">Go to
          location </span>
      </p>
    </div>
  </div>
</template>
<script>
import { mapMutations } from 'vuex'
import { setTimeout } from 'timers'
import cookies from '@/services/cookies'

export default {
  data() {
    return {
      name: '',
      seen: false,
      index: null,
      loader: false,
      location: null,
      location_id: null,
      id: null,
      found: false,
      done: false,
      selected_folder_id: '',
      dir: [],
      movedfile: '',
      destination: '',
      destination_id: ''
    }
  },
  methods: {
    ...mapMutations([
      'UPDATE_TOTAL_USED_SPACE',
      'SET_DIRECTORY_CHILDREN',
      'SET_CURRENT_DIRECTORY',
      'SET_PATH',
      'SORT_DIRECTORY_CHILDREN',
      'SET_STORED_DIRECTORY_CHILDREN',
      'EMPTY_FILES_INDEX',
      'SET_SELECT_ALL',
      'SET_FILE_ACTION'
    ]),
    logincall() {
      this.$parent.logincall()
    },
    str_text(str) {
      if (str.length > 24) {
        let fSeg = str.substring(0, 5)
        let sSeg = str.substr(str.length - 7, 7)

        return fSeg + '....' + sSeg
      }
      return str
    },
    load(id, location) {
      this.seen = true
      this.location = location
      this.location_id = id
      this.selected_folder_id = id
      let that = this
      let indexes = Object.values(that.$store.getters.GET_FILES_INDEX)
      let groupedfiles = {}
      indexes.map(index => {
        groupedfiles[that.$store.getters.DIRECTORY_CHILDREN[index].id] = {
          index: index,
          ignore: false,
          is_checked: false,
          id: that.$store.getters.DIRECTORY_CHILDREN[index].id
        }
      })

      let data = {
        token: cookies.getCookie('token'),
        move_files: groupedfiles,
        selected_folder_id: this.selected_folder_id
      };

      this.$socket.emit('group-move-file', data, function (data) {
        if (data.data === true) {
          that.done = true
          that.destination = data.destination
          that.dir = data.dir
          that.selected_folder_id = data.dir.id
          that.EMPTY_FILES_INDEX()
          that.SET_SELECT_ALL(false)
          that.SET_FILE_ACTION('')
          //let total_space_used = that.$store.getters.GET_TOTAL_USED_SPACE - data.trash_size
          //that.UPDATE_TOTAL_USED_SPACE(total_space_used)

          that.$store.getters.DIRECTORY_CHILDREN.map(file => {
            file.is_checked = false
          })
        }

        if (data.message === 'exist') {
          that.seen = false
          that.fileExist(data.location_id, data.old_name, data.selected_folder_name, data.new_name, data.files, data.current_file_id)
        }

        if (data.data === false) {
          that.seen = false
          that.logincall()
          that.$router.push('/login')
        }
      })
    },
    goto() {
      if (this.selected_folder_id) {
        this.loading = false;
        this.wait = false;

        let that = this;

        let data = {
          db: this.dir.db,
          token: cookies.getCookie('token'),
          current_directory_id: this.selected_folder_id
        }

        this.$socket.emit("browse", data, function (data) {
          if (data.message === "completed") {
            localStorage.setItem('current_directory_id', that.selected_folder_id)
            localStorage.setItem('current_directory', that.dir.name)
            localStorage.setItem('db', that.dir.db)
            that.SET_DIRECTORY_CHILDREN(data.directory_children)
            that.SET_STORED_DIRECTORY_CHILDREN(data.directory_children)
            that.SET_CURRENT_DIRECTORY(that.dir.name)
            that.SET_PATH(data.dir_path)
            that.SORT_DIRECTORY_CHILDREN()
            that.seen = false
          }

          if (data.data == false) {
            that.seen = false
            that.logincall();
            that.$router.push('/login')
          }
        });
      }
    },
    fileExist(location_id, old_name, selected_folder_name, new_name, files, current_file_id) {
      this.$parent.group_file_exist(location_id, selected_folder_name, old_name, new_name, files, current_file_id, 'move')
    },
    closebox() {
      this.seen = false
    }
  }
}
</script>